//  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//  !!! IT MUST BE IN LOWER CASE !!!
//  !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export const PROD = "prod";
export const DEV = "dev";
export const WEB = "web";

export const SERVER_TIME_CORRECTION = 3;

// Default portal language
export const BASE_LANG = "pt_br";
export const DEFAULT_LANGUAGE = "pt";
export const VIDEO = "video";
export const GAME = "game";
export const AUDIO = "audio";
export const TEXT = "text";

export const ALL = "todos";
export const ALL_AUDIOS = "todos-audios";
export const ALL_GAMES = "todos-jogos";
export const MY_ACTIVITIES = "minhas-atividades";
export const MY_GOALS = "metas";


// Default alerts
export const ALERT_TYPE_SUCCESS = "success";
export const ALERT_TYPE_WARNING = "warning";
export const ALERT_TYPE_DANGER = "danger";

export const PAID = "paid";
export const FREE = "free";
export const FONO = "fono";
// Default images
export const DEFAULT_DIR_AVATAR_2ponto0 =
  "https://h.afinando.com.br/static/images/avatar/";

export const DEFAULT_AVATAR_IMG =
  "https://h.afinando.com.br/static/images/avatar/no-image.jpg";

// ========== Media Queries ==========
// ----------- FULL PAGE -----------
export const ASIDE_CLASS = " col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 ";
// Classes from Main and header HOCs
export const MAIN_HAS_ASIDE_CLASS =
  " col-12 col-sm-12 col-md-12 col-lg-9 col-xl-8 ";
export const HAS_ASIDE_CLASS =
  " col-12 offset-0 col-md-9 offset-md-3 col-lg-7 offset-lg-3 col-xl-8 offset-xl-2 ";
// No Aside
export const MAIN_NO_ASIDE_CLASS =
  " col-12 offset-0 offset-md-0 col-md-12 col-lg-10 offset-lg-1 col-xl-9 offset-xl-1 ";
// " col-12 offset-0 col-md-10 offset-sm-0 offset-md-1 col-lg-8 offset-lg-2 ";
export const NO_ASIDE_CLASS =
  " col-12 offset-0 col-md-10 offset-md-1 col-lg-8 offset-lg-2 ";
// No Aside and full width
export const MAIN_NO_ASIDE_CLASS_FULL =
  " col-12 offset-0 col-xl-10 offset-xl-1 ";
export const NO_ASIDE_CLASS_FULL = " col-12 offset-0 col-xl-10 offset-xl-1 ";

// ----------- ASIDE MENU PAGE -----------
export const USER_INNER_ASIDE_CLASS =
  " col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 ";
export const USER_INNER_MAIN_CLASS =
  " col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 ";

export const CARD_2_WITH_ASIDE = "col-12 col-sm-6 col-xl-6";
export const CARD_3_WITH_ASIDE = "col-12 col-sm-6 col-xl-4";
export const CARD_3_WITH_FIXED_ASIDE = "col-12 col-md-6 col-xl-3";
export const CARD_3_WITHOUT_ASIDE = "col-12 col-sm-6 col-lg-5 col-xl-3";
export const CARD_4_WITHOUT_ASIDE = "col-12 col-sm-6 col-lg-4 col-xl-3";

// ----------- CARD TAG LOGIN -----------
export const TAB_CARD_LOGIN = " col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4";
